import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Select,
  Input,
  Form,
  Row,
  Col,
  Space,
  Typography,
} from "antd";
import { FaEye } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../features/students/studentSlice";
import { Link } from "react-router-dom";
import PopupModal from "../components/PopupModal";
import moment from "moment";
import { ExportOutlined, PlusOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { getStates } from "../features/statecity/statecitySlice";
import { getBrands } from "../features/brand/brandSlice";

const { Search } = Input;
const { Title } = Typography;

const columns = [
  {
    title: "Class",
    dataIndex: "Class",
  },
  {
    title: "Roll No",
    dataIndex: "Roll_Number",
  },
  {
    title: "Name",
    dataIndex: "Student_name",
    sorter: (a, b) => a.Student_name.length - b.Student_name.length,
  },
  {
    title: "School",
    dataIndex: "School",
  },
  {
    title: "Phone No",
    dataIndex: "Phone_no",
  },
  {
    title: "State",
    dataIndex: "State",
  },
  {
    title: "District",
    dataIndex: "District",
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    render: (text) => moment(text).format("YYYY-MM-DD"),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const csvHeaders = [
  { label: "Class", key: "Class" },
  { label: "Roll Number", key: "Roll_Number" },
  { label: "Student Name", key: "Student_name" },
  { label: "Phone No", key: "Phone_no" },
  { label: "Guardian Name", key: "Guardian_name" },
  { label: "Student Address", key: "Student_address" },
  { label: "Districts", key: "District" },
  { label: "Created At", key: "createdAt" },
];

const Students = () => {
  const [open, setOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  // const [filteredOptions, setFilteredOptions] = useState([]);
  const [vcData, setvcData] = useState([]);
  // const [modalVisible, setModalVisible] = useState(false);
  // const [vtData, setvtData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setselectedDistrict] = useState("");
  // const [selectedVC, setselectedVC] = useState("");
  // const [selectedVT, setSelectedVT] = useState("");
  // const [selectedClass, setSelectedClass] = useState("");
  const [districtOptions, setDistrictOptions] = useState([]);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [filteredAllStudent, setfilteredAllStudent] = useState([]);

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const studentState = useSelector((state) => state.student.students);
  const statelistState = useSelector(
    (state) => state.statecity.statelist || []
  );
  const vclistState = useSelector((state) => state.customer.customers || []);
  //const classlistState = useSelector((state) => state.brand.brands || []);

  useEffect(() => {
    dispatch(getUsers());
    dispatch(getStates());
    dispatch(getBrands());
  }, [dispatch]);

  useEffect(() => {
    if (studentState.length > 0 && !initialDataLoaded) {
      handleSubmit();
      setInitialDataLoaded(true);
    }
  }, [studentState, initialDataLoaded]);

  const showModal = (student) => {
    setSelectedStudent(student);
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
    setSelectedStudent(null);
  };

  const transformedData = filteredAllStudent.map((student) => ({
    ...student,
    action: (
      <Link className="text-primary" onClick={() => showModal(student)}>
        <FaEye />
      </Link>
    ),
  }));

  const handleSearch = (value) => {
    setSearchValue(value);
    const filteredData = transformedData.filter((student) => {
      const searchString = value.toLowerCase();
      return (
        student.Roll_Number.toLowerCase().includes(searchString) ||
        student.Student_name.toLowerCase().includes(searchString) ||
        student.Phone_no.toLowerCase().includes(searchString) ||
        student.Guardian_name.toLowerCase().includes(searchString) ||
        student.Student_address.toLowerCase().includes(searchString) ||
        moment(student.createdAt).format("YYYY-MM-DD").includes(searchString)
      );
    });
    setFilteredData(filteredData);
  };

  const handleChange = (value) => {
    handleSearch(value);
  };

  const handleClear = () => {
    setSearchValue("");
    setFilteredData([]);
  };

  useEffect(() => {
    if (selectedState) fetchDistricts(selectedState);
  }, [selectedState]);

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setSelectedState(value);
  };

  const fetchDistricts = async (stateCode) => {
    const vtfilterData = statelistState.filter(
      (distric) => distric.state === stateCode
    );
    setDistrictOptions(vtfilterData);
    setLoadingDistricts(true);
  };

  const handleDistrictChange = (value) => {
    setselectedDistrict(value);
  };

  const handleSubmit = () => {
    console.log(
      "Print all 2 Filter Query Data ---",
      selectedState + " " + selectedDistrict
    );
    console.log("Print School List State ----", studentState);

    const filteredData = studentState.filter((student) => {
      const matchesState = selectedState
        ? student.State === selectedState
        : true;
      const matchesDistrict = selectedDistrict
        ? student.District === selectedDistrict
        : true;

      return matchesState && matchesDistrict;
    });
    console.log("Print Filter Data ---- ", filteredData);

    setfilteredAllStudent(filteredData);
  };

  const handleClears = () => {
    form.resetFields();
    setSelectedState("");
    setselectedDistrict("");
    setfilteredAllStudent(studentState);
    setDistrictOptions([]);
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={3} className="mb-4">
        All Students
      </Title>
      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Link to="/admin/add-student">
              <Button type="primary" icon={<PlusOutlined />}>
                Add Students
              </Button>
            </Link>
          </Col>
          <Col>
            <Space>
              <Search
                placeholder="Search by"
                style={{ width: 300 }}
                onSearch={handleSearch}
                onChange={handleChange}
              />
              <CSVLink
                data={transformedData}
                headers={csvHeaders}
                filename={`Student-List${new Date().toISOString()}.csv`}
              >
                <Button type="primary" icon={<ExportOutlined />}>
                  Export to CSV
                </Button>
              </CSVLink>
            </Space>
          </Col>
        </Row>

        <Form form={form} layout="inline" onFinish={handleSubmit}>
          <Form.Item
            name="state_name"
            rules={[
              {
                required: true,
                message: "Please Select State!",
              },
            ]}
          >
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select State"
              onChange={handleStateChange}
            >
              {statelistState.map((i, j) => (
                <Select.Option key={j} value={i.state}>
                  {i.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="district">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select District"
              onChange={handleDistrictChange}
              // loading={loadingDistricts}
              disabled={!selectedState}
            >
              {districtOptions.map((district) =>
                district.district_name.map((districtName, idx) => (
                  <Select.Option key={idx} value={districtName}>
                    {districtName}
                  </Select.Option>
                ))
              )}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<FaEye />}>
              View
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="default" onClick={handleClears}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Table
        columns={columns}
        className="custom-table"
        dataSource={filteredData.length ? filteredData : transformedData}
        // pagination={{ pageSize: 20 }}
        size="small"
      />

      <PopupModal open={open} hideModal={hideModal} student={selectedStudent} />
    </div>
  );
};

export default Students;
